export default {
  menu: 'Sale flow products',
  title: 'Sale flow products',

  general: {
    labels: {
      id: 'Invoice ID',
      user: 'Customer',
      fullName: 'Full Name',
      address: 'Address',
      email: 'Email',
      registryDate: 'Registration Date',
      orderDate: 'Order Date',
      phoneNumber: 'Phone number',
      pre: 'pre',
      status: 'Status',
      gift: 'Gift',
      store: 'Store',
      note: 'Note',
      cooperation: 'Cooperation',
      availableProduct: 'Available Products',
      allProduct: 'All Products',
      search: 'Scan barcode',
      cart: 'Cart ({count})',
      clearCart: 'Clear cart',
      hold: 'Hold',
      emptyCart: 'Cart is empty',
      payment: 'Payment',
      received: 'Received',
      newSale: 'New sale',
      completeSale: 'Complete sale',

      productPrice: 'Products price',
      servicePrice: 'Services price',
      tax: 'Vat amount',
      totalDiscount: 'Discount',
      totalVatExc: 'Total (vat EXC)',
      totalPrice: 'Total price',
      totalVatInc: 'Total',
      grandTotal: 'Grand total',
      shipping: 'Shipping',
      required: '(required)',
      totalCount: 'Qty',
      totalVat: 'Total vat',
      total: 'Amount',
      totalGrand: 'Grand total',
      TRN: 'TRN: ',
      vatExc: 'vat Exc',
      vatInc: 'vat Inc',
      vatContainTextBefore: 'includes ',
      vatContainTextAfter: 'VAT amount',
      attachmentLabel: 'Attachment {key}',
      services: {
        name: 'Service name',
        quantity: 'Quantity',
        price: 'Price'
      }
    },

    actionTypes: {
      present: 'Retail',
      tel: 'Telephone',
      internet: 'Internet',
      cod: 'COD'
    },

    processTypes: {
      proformaInvoices: 'Draft',
      invoices: 'Invoice',
      storeExit: 'Pull out',
      incomplete: 'Incomplete',
      cancelled: 'Cancelled'
    },

    offlinePayments: {
      true: 'Yes',
      false: 'No'
    },
  },

  list: {
    title: 'Sale flow products',

    table: {
      header: {
        referenceId: 'Reference',
        creator: 'Creator',
        user: 'Customer',
        barcode: 'Barcode',
        name: 'Product',
        storeroom: 'Store',
        unitPrice: 'Unit',
        count: 'QTY',
        date: 'Date',
        totalDiscount: 'Discount',
        totalVat: 'Vat',
        shipping: 'Shipping',
        finalPrice: 'Grand Amt',
        type: 'Type',
        status: 'Status',
        offlinePayment: 'COD',
        canceledInvoice: 'Canceled Invoice Ref',
        restore: 'Restore',
        delete: 'Delete'
      },

      filters: {
        type: {
          all: 'All',
          present: 'Retail',
          tel: 'Telephone',
          internet: 'Internet'
        },

        status: {
          all: 'All',
          proformaInvoices: 'Draft',
          invoices: 'Invoice',
          storeExit: 'Pull out',
          incomplete: 'Incomplete',
          cancelled: 'Cancelled'
        },

        offlinePayments: {
          true: 'Yes',
          false: 'No'
        }
      }
    },

    actionTypes: {
      present: 'Retail',
      tel: 'Telephone',
      internet: 'Internet'
    }
  }
}
